var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.86 4 9.86899 4.19825 9.00586 4.53864L8.27211 2.6781C9.38133 2.24065 10.6225 2 12 2C13.3775 2 14.6187 2.24065 15.7279 2.6781L14.9941 4.53864C14.131 4.19825 13.14 4 12 4Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2619 5.52698C5.65339 6.75841 4.54823 8.63472 3.86347 10.6902L1.96599 10.0581C2.72913 7.76733 4.01737 5.49209 6.04613 3.93893L7.2619 5.52698Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1365 10.6902C19.4518 8.63472 18.3466 6.75841 16.7381 5.52698L17.9539 3.93893C19.9826 5.49209 21.2709 7.76733 22.034 10.0581L20.1365 10.6902Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16C21 15.0237 20.9023 13.9173 20.6814 12.7789L22.6448 12.398C22.8899 13.6616 23 14.8956 23 16H21Z",
    fill: "#647B8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31861 12.7789C3.09774 13.9173 3 15.0237 3 16H1C1 14.8956 1.11005 13.6616 1.35523 12.398L3.31861 12.7789Z",
    fill: "#647B8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18L8 22V19H16V22L21 18L16 14V17H8V14L3 18Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGap);
export default __webpack_public_path__ + "static/media/gap.554ef1e2.svg";
export { ForwardRef as ReactComponent };